import { AddIcon, CloseIcon } from "@chakra-ui/icons";
import {
  Box,
  Button,
  Divider,
  FormControl,
  FormLabel,
  Grid,
  IconButton,
  Input,
  Text,
  HStack,
  Th,
  Table,
  Thead,
  Tr,
  Tbody,
  Td,
  List,
  ListItem,
  Spinner,
  Portal,
  Tooltip,
  Radio,
  RadioGroup,
  Switch,
  InputGroup,
  InputRightElement,
} from "@chakra-ui/react";
import { useEffect, useState, useRef, useCallback, useContext } from "react";
import { appRequest } from "routes";
import CustomInput from "components/common/customInput/CustomInput";
import {
  currencyOptions
} from "../../common/constant";
import { AppContext } from "AppProvider/AppContext";
import { addNA, addNAObject } from "../../common/function";
import CrmTdsGlSection from "./CrmTdsGlSection";

const COMPANY_CODES = [
  "EBL", "EMX", "ENL", "ELPL", "ENZ", "EPC", "ESA", "EPE", "EPP", "EWPL", "EAU", "EPL", "EMN", "EPDR", "EUK", "EBT", "EMCT", "EUS", "AVL", "LPK", "MNPI", "MPI", "TII", "TIL", "TIM", "ZHL"
];

const companyOptions = [
  { label: "Avet Lifesciences Pvt Ltd", value: "AVL" },
  { label: "Emcure Australia", value: "EAU" },
  { label: "Emcure Brasil", value: "EBL" },
  { label: "Gennova Biopharmaceutical", value: "EBT" },
  { label: "Emcure Life Science Pvt L", value: "ELPL" },
  { label: "Emcutix Biopharmaceutical", value: "EMCT" },
  { label: "Emcure Pharmaceutical Men", value: "EMN" },
  { label: "Emcure Mexico", value: "EMX" },
  { label: "Emcure Nigeria Limited", value: "ENL" },
  { label: "Emcure NZ Ltd", value: "ENZ" },
  { label: "EMCURE PHARMA CHILE S.P.A", value: "EPC" },
  { label: "EMCURE PHARMACEUTICALS", value: "EPDR" },
  { label: "Emcure Pharma Peru S.A.C.", value: "EPE" },
  { label: "Emcure Pharmaceuticals", value: "EPL" },
  { label: "Emcure Pharma Philippines", value: "EPP" },
  { label: "Emcure South Africa", value: "ESA" },
  { label: "Emcure Pharma UK Ltd.", value: "EUK" },
  { label: "Avet Pharma Labs Inc.", value: "EUS" },
  { label: "Emcure Wellness Private", value: "EWPL" },
  { label: "Lazor Pharmaceuticals Ltd", value: "LPK" },
  { label: "Mantra Pharma Inc", value: "MNPI" },
  { label: "Marcan Pharmaceuticals In", value: "MPI" },
  { label: "Tillomed Italia S.R.L.", value: "TII" },
  { label: "Tillomed Malta Ltd", value: "TIM" },
  { label: "Australia (EAU)", value: "EAU" }

];

const editableInputProps = {
  size: "sm",
  h: "36px",
  bg: "gray.50",
  borderRadius: "md",
  borderColor: "gray.300",
  _hover: { bg: "white", borderColor: "gray.400" },
  _focus: {
    borderColor: "blue.500",
    boxShadow: "0 0 0 3px rgba(66, 153, 225, 0.3)",
  },
};

const emergingInvoiceTypeOptions = [
  { label: "KG - Vendor Credit Memo", value: "KG" },
  { label: "KR - Vendor Invoice", value: "KR" },
];

interface LineItem {
  profitCenter: any;
  costCenter: any;
  businessArea: any;
  internalOrder: any;
  remark: string;
  taxCode: any;
  drCrIndicator: any;
  lineNarration: string;
  glAccount: any;
  glDescription: string;
  glAmount: string | number;
  netAmount: string | number;
  taxAmount: string | number;
  plantCode: string;
  businessPlace: string;
  hsnCode: string;
  rowId: string;
}

interface EmergingFormProps {
  value: any;
  onChange: (updated: any) => void;
  workflowProcess?: any;
  showTds?: any;
  tdsFifthApproval?: any;
  disabledOtherUserField?: any;
  gstUser?: any;
  triggerValidation?: boolean;
}

export default function CrmForm({
  value = {},
  onChange,
  workflowProcess,
  disabledOtherUserField,
  triggerValidation,
}: EmergingFormProps) {
  const { accountDetails } = useContext(AppContext);
  const getInitialDrCr = (val: any) => {
    const type = typeof val?.invoiceType === "object" ? val?.invoiceType?.value : val?.invoiceType;
    return type === "KG" ? { label: "Credit", value: "H" } : type === "KR" ? { label: "Debit", value: "S" } : null;
  };

  const [form, setForm] = useState<any>(() => {
    const initialDrCr = getInitialDrCr(value);
    return {
      companyCode: null,
      buyerName: "",
      vendorGstIn: "",
      vendorCode: "",
      vendorName: "",
      vendorAddress: "",
      vendorPan: "",
      vendorText: "",
      Invoice_Number: "",
      Invoice_Date: "",
      Grand_Total: "",
      invoiceType: null,
      currency: "",
      headerText: "",
      reference1: "",
      reference2: "",
      reference3: "",
      postingDate: "",
      isTdsApplicable: false,
      tdsSectionType: "tds",
      tdsTaxCode: null,
      tdsBasicAmount: "",
      glProfitCenter: null,
      glCostCenter: null,
      glBusinessArea: null,
      glPlantCode: null,
      glBusinessPlace: null,
      glInternalOrder: null,
      glAccount: null,
      glDescription: "",
      glAmount: "",
      glLineNarration: "",
      glRemark: "",
      roundOff: "0.00",
      lineItems: [
        {
          profitCenter: null,
          costCenter: null,
          businessArea: null,
          internalOrder: null,
          remark: "",
          taxCode: null,
          drCrIndicator: initialDrCr || "",
          lineNarration: "",
          glAccount: null,
          glDescription: "",
          glAmount: "",
          netAmount: "",
          taxAmount: "",
          plantCode: "",
          businessPlace: "",
          hsnCode: "",
          rowId: Date.now().toString(),
        },
      ],
      ...value,
    };
  });

  const [vendorSearch, setVendorSearch] = useState(value.vendorCode || "");
  const [vendorList, setVendorList] = useState<any[]>([]);
  const [showVendorList, setShowVendorList] = useState(false);
  const [isVendorLoading, setIsVendorLoading] = useState(false);

  const [isOptionsLoading, setIsOptionsLoading] = useState(false);
  const [companyCodeOptions, setCompanyCodeOptions] = useState<any[]>(
    COMPANY_CODES.map(code => ({ label: companyOptions.find(c => c.value === code)?.label || code, value: code }))
  );
  const [tdsTaxCodeOptions, setTdsTaxCodeOptions] = useState<any[]>([]);

  const vendorContainerRef = useRef<HTMLDivElement>(null);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const vendorTimerRef = useRef<NodeJS.Timeout | null>(null);

  const onChangeRef = useRef(onChange);
  const workflowProcessRef = useRef(workflowProcess);
  const isInternalUpdating = useRef(false);
  const initialSyncDone = useRef(false);
  const [showValidation, setShowValidation] = useState(false);

  // Sync showValidation from parent if needed, but we'll also trigger it internally
  useEffect(() => {
    if ((value as any).triggerValidation || triggerValidation) {
      setShowValidation(true);
    }
  }, [value, triggerValidation]);

  useEffect(() => { onChangeRef.current = onChange; }, [onChange]);
  useEffect(() => { workflowProcessRef.current = workflowProcess; }, [workflowProcess]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (!vendorContainerRef.current?.contains(event.target as Node) && !dropdownRef.current?.contains(event.target as Node)) {
        setShowVendorList(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  console.log("form", value);
  const updateForm = useCallback((updates: any | ((prev: any) => any)) => {
    setForm((prev: any) => {
      const next = typeof updates === "function" ? updates(prev) : { ...prev, ...updates };

      // Calculate Round Off: Grand Total - Sum(Net Amount + Tax Amount) of all line items
      const totalLineItemsAmount = (next.lineItems || []).reduce((acc: number, item: any) => {
        const net = parseFloat(item.netAmount);
        const tax = parseFloat(item.taxAmount);
        const lineTotal = (isNaN(net) ? 0 : net) + (isNaN(tax) ? 0 : tax);
        return acc + lineTotal;
      }, 0);

      const grandTotal = parseFloat(next.Grand_Total);
      const calculatedRoundOff = ((isNaN(grandTotal) ? 0 : grandTotal) - totalLineItemsAmount).toFixed(2);
      next.roundOff = calculatedRoundOff;

      const cleanedNext = next;
      if (JSON.stringify(prev) !== JSON.stringify(cleanedNext)) {
        isInternalUpdating.current = true;
        onChangeRef.current(cleanedNext);
        setTimeout(() => { isInternalUpdating.current = false; }, 300);
      }
      return next;
    });
  }, []);

  const updateLineItem = useCallback((index: number, updates: Partial<LineItem>) => {
    updateForm((prev: any) => {
      const newLineItems = [...prev.lineItems];
      if (newLineItems[index]) newLineItems[index] = { ...newLineItems[index], ...updates };
      return { ...prev, lineItems: newLineItems };
    });
  }, [updateForm]);

  const lastDocId = useRef<string | null>(null);

  useEffect(() => {
    const currentId = value?._id || value?.Invoice_Number || "";
    const isNewDoc = currentId !== lastDocId.current;

    if (isNewDoc) {
      isInternalUpdating.current = false;
      lastDocId.current = currentId;
    }

    if (isInternalUpdating.current) return;

    let updatedValue = { ...value };
    const type = typeof updatedValue.invoiceType === "object" ? updatedValue.invoiceType?.value : updatedValue.invoiceType;
    const defaultDrCr = type === "KG" ? { label: "Credit", value: "H" } : type === "KR" ? { label: "Debit", value: "S" } : null;

    if (updatedValue.lineItems) {
      updatedValue.lineItems = updatedValue.lineItems.map((item: any) => {
        let drCr = item.drCrIndicator;
        if (typeof drCr === "string" || !drCr) {
          if (drCr === "C" || drCr === "H") drCr = { label: "Credit", value: "H" };
          else if (drCr === "D" || drCr === "S") drCr = { label: "Debit", value: "S" };
          else if (!drCr && defaultDrCr) drCr = defaultDrCr;
        }
        return { ...item, drCrIndicator: drCr };
      });
    }

    setForm((prev: any) => ({ ...prev, ...updatedValue }));
    if (value.vendorCode !== undefined && value.vendorCode !== vendorSearch) setVendorSearch(value.vendorCode || "");
  }, [value]);

  const [fetchingRows, setFetchingRows] = useState<Set<string>>(new Set());
  const pcCache = useRef<{ [key: string]: string }>({});
  const lastCompanyCode = useRef<string | null>(null);

  const handleCostCenterBlur = useCallback(async (costCenter: string) => {
    const code = typeof form.companyCode === "object" ? form.companyCode?.value : form.companyCode;
    if (!costCenter || !code) return;

    // Check cache first
    if (pcCache.current[costCenter]) {
      const cachedPc = pcCache.current[costCenter];
      updateForm((prev: any) => ({
        ...prev,
        lineItems: prev.lineItems.map((it: any) =>
          it.costCenter === costCenter ? { ...it, profitCenter: cachedPc } : it
        )
      }));
      return;
    }

    setFetchingRows(prev => {
      const next = new Set(prev);
      next.add(costCenter);
      return next;
    });

    try {
      const payload = {
        companyCode: code,
        costCenter: costCenter,
        processName: "crm"
      };

      const res: any = await appRequest("crmprofitcenter", "get", payload);

      if (res?.status === "success" && Array.isArray(res?.data) && res.data.length > 0) {
        const profitCenter = res.data[0].profitCenter || res.data[0].value || res.data[0].label || "";

        // Store in cache
        pcCache.current[costCenter] = profitCenter;

        updateForm((prev: any) => ({
          ...prev,
          lineItems: prev.lineItems.map((it: any) =>
            it.costCenter === costCenter ? { ...it, profitCenter: profitCenter } : it
          )
        }));
      } else {
        // If not found, store empty in cache but don't force reset here
        // because it was already handled in onChange or we want to keep it.
        pcCache.current[costCenter] = "";
      }
    } catch (error) {
      console.error("Error fetching profit center:", error);
    } finally {
      setFetchingRows(prev => {
        const next = new Set(prev);
        next.delete(costCenter);
        return next;
      });
    }
  }, [form.companyCode, updateForm]);

  const ccTimers = useRef<{ [key: string]: NodeJS.Timeout }>({});
  const lastCostCenters = useRef<{ [key: string]: string }>({});

  useEffect(() => {
    const code = typeof form.companyCode === "object" ? form.companyCode?.value : form.companyCode;
    if (!code) return;

    // If company code changes, clear cache and re-fetch all active cost centers
    // On initial load, lastCompanyCode.current will be null
    const isInitialLoad = lastCompanyCode.current === null;
    const codeChanged = !isInitialLoad && code !== lastCompanyCode.current;

    if (codeChanged || isInitialLoad) {
      if (codeChanged) pcCache.current = {};
      lastCompanyCode.current = code;
    }

    const ccsToFetch = new Set<string>();

    form.lineItems.forEach((item: LineItem, index: number) => {
      const rowId = item.rowId;
      const currentCC = item.costCenter || "";
      const lastCC = lastCostCenters.current[rowId];

      // Only trigger auto-fetch if:
      // 1. Cost Center explicitly changed from a previous value (lastCC was defined and different)
      // 2. Company Code changed (and we have a CC)
      // 3. It's a new row/initial load AND Profit Center is empty but Cost Center is present
      const ccChanged = lastCC !== undefined && currentCC !== lastCC;
      const needsInitialFetch = lastCC === undefined && !item.profitCenter && currentCC;

      if (codeChanged || ccChanged || needsInitialFetch) {
        if (currentCC.length >= 2) {
          ccsToFetch.add(currentCC);
        } else if (!currentCC && item.profitCenter && (ccChanged || codeChanged)) {
          updateLineItem(index, { profitCenter: "" });
        }
      }

      lastCostCenters.current[rowId] = currentCC;
    });

    // Handle debounced fetching per unique Cost Center
    ccsToFetch.forEach(cc => {
      if (ccTimers.current[cc]) clearTimeout(ccTimers.current[cc]);
      ccTimers.current[cc] = setTimeout(() => {
        handleCostCenterBlur(cc);
      }, 600);
    });

    return () => {
      // Per-CC cleanup managed individually
    };
  }, [form.lineItems, handleCostCenterBlur, form.companyCode, updateLineItem]);



  useEffect(() => {
    const type = form.invoiceType?.value;
    if (!type) return;

    const drCr = type === "KG" ? { label: "Credit", value: "H" } : type === "KR" ? { label: "Debit", value: "S" } : null;
    if (!drCr) return;

    const needsUpdate = form.lineItems.some((item: any) => {
      const currentVal = typeof item.drCrIndicator === "object" ? item.drCrIndicator?.value : item.drCrIndicator;
      return currentVal !== drCr.value;
    });

    if (needsUpdate) {
      updateForm((prev: any) => ({
        ...prev,
        lineItems: prev.lineItems.map((item: any) => {
          const currentVal = typeof item.drCrIndicator === "object" ? item.drCrIndicator?.value : item.drCrIndicator;
          return currentVal !== drCr.value ? { ...item, drCrIndicator: drCr } : item;
        })
      }));
    }
  }, [form.invoiceType, updateForm]);

  useEffect(() => {
    const fetchCompanyCodes = async () => {
      try {
        const buyerName = form.buyerName;

        if (!buyerName) return;

        const payload = {
          buyerName,
          type: "getCompanyCode",
          ...workflowProcessRef.current,
        };
        const response: any = await appRequest("user", "masterFinancialApi", payload);
        if (response?.status === "success") {
          const options = (response?.data || []).map((item: any) => ({
            label: companyOptions.find(c => c.value === item)?.label || item,
            value: item,
          }));
          if (options.length > 0) {
            // setCompanyCodeOptions(options);
            if (!form.companyCode) {
              updateForm({ companyCode: options[0] });
            }
          }
        }
      } catch (error) {
        console.error(error);
      }
    };
    fetchCompanyCodes();
  }, [form.buyerName]);


  useEffect(() => {
    const fetchVendorData = async () => {
      const code = typeof form.companyCode === "object" ? form.companyCode?.value : form.companyCode;
      const gstin = form.vendorGstIn;
      const vCode = form.vendorCode;

      // Only proceed if we have companyCode AND (gstin OR vCode)
      if (!code || (!gstin && !vCode)) return;

      // If we already have Name and Address, no need to auto-fetch (prevents infinite loops)
      if (form.vendorName && form.vendorAddress) return;

      setIsVendorLoading(true);
      try {
        const payload = {
          companyCode: code,
          type: "getVendorByName",
          vendorName: gstin || vCode || undefined,
          ...workflowProcessRef.current,
        };
        const res: any = await appRequest("user", "masterFinancialApi", payload);
        if (res?.status === "success" && Array.isArray(res?.data) && res.data.length > 0) {
          const firstVendor = res.data[0];
          updateForm({
            vendorCode: firstVendor.vendorCode || vCode || "",
            vendorName: firstVendor.supplierName || firstVendor.label || firstVendor.vendorName || "",
            vendorAddress: firstVendor.vendorAddress || ""
          });
          if (!vendorSearch) setVendorSearch(firstVendor.vendorCode || vCode || "");
        }
      } catch (err) {
        console.error(err);
      } finally {
        setIsVendorLoading(false);
      }
    };
    fetchVendorData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [form.companyCode, form.vendorGstIn, form.vendorCode]);

  useEffect(() => {
    const code = typeof form.companyCode === "object" ? form.companyCode?.value : form.companyCode;
    const vCode = form.vendorCode;
    if (!code || !vCode) return;

    const fetchTdsTaxCodes = async () => {
      try {
        const payload = {
          type: "getTdsTaxCode",
          companyCode: code,
          vendorCode: vCode,
          ...workflowProcess,
        };
        const response: any = await appRequest("user", "masterFinancialApi", payload);
        if (response?.status === "success" && Array.isArray(response?.data)) {
          const options = response.data.map((code: any) => ({
            label: code?.label || code?.tdsTaxCode,
            value: code?.tdsTaxCode
          }));
          setTdsTaxCodeOptions(options);
        } else {
          setTdsTaxCodeOptions([]);
        }
      } catch (error) {
        console.error("Failed to load TDS Tax Codes", error);
      }
    };
    fetchTdsTaxCodes();
  }, [form.companyCode, form.vendorCode, workflowProcess]);


  useEffect(() => {
    if (vendorTimerRef.current) clearTimeout(vendorTimerRef.current);
    const trimmed = vendorSearch.trim();
    if (!trimmed || trimmed.length < 2 || trimmed === form.vendorCode) return;
    vendorTimerRef.current = setTimeout(async () => {
      setIsVendorLoading(true);
      try {
        const res: any = await appRequest("user", "masterFinancialApi", { type: "getVendorByName", vendorName: trimmed, companyCode: form.companyCode?.value, ...workflowProcessRef.current });
        if (res?.status === "success") setVendorList(res.data || []);
        setShowVendorList((res.data || []).length > 0);
      } catch (err) { console.error(err); } finally { setIsVendorLoading(false); }
    }, 600);
  }, [vendorSearch, form.vendorCode, form.companyCode]);

  const handleSelectVendor = (vendor: any) => {
    updateForm({ vendorCode: vendor.vendorCode || "", vendorName: vendor.supplierName || vendor.label || "", vendorAddress: vendor.vendorAddress || "" });
    setVendorSearch(vendor.vendorCode || "");
    setShowVendorList(false);
  };





  const addLineItem = () => {
    const type = form.invoiceType?.value;
    const drCr = type === "KG" ? { label: "Credit", value: "H" } : type === "KR" ? { label: "Debit", value: "S" } : null;
    updateForm((prev: any) => ({
      ...prev,
      lineItems: [...prev.lineItems, { profitCenter: "", costCenter: "", businessArea: "", internalOrder: "", remark: "", taxCode: "", drCrIndicator: drCr, lineNarration: "", glAccount: "", glDescription: "", glAmount: "", netAmount: "", taxAmount: "", plantCode: "", businessPlace: "", hsnCode: "", rowId: Date.now().toString() + Math.random().toString(36).substr(2, 9) }]
    }));
  };

  const removeLineItem = (index: number) => {
    updateForm((prev: any) => prev.lineItems.length > 1 ? { ...prev, lineItems: prev.lineItems.filter((_: any, i: number) => i !== index) } : prev);
  };


  return (
    <Box maxH="75vh" overflowY="auto" pr={3}>
      <Text fontSize="xs" fontWeight="bold" color="blue.600" mb={4} textTransform="uppercase">General Header Data</Text>
      <Grid gridTemplateColumns={"1fr 1fr 1fr"} gap={4}>
        <CustomInput name="companyCode" label="Company Code" type="select" isBoxSelect isRequired={true} value={form.companyCode} onChange={(val: any) => updateForm({ companyCode: val, buyerName: val.label })} options={companyCodeOptions} disabled={disabledOtherUserField} error="Required" showError={showValidation && !form.companyCode} />
        <CustomInput name="buyerName" label="Buyer Name" value={form.buyerName || ""} onChange={(e: any) => updateForm({ buyerName: e.target.value })} disabled={disabledOtherUserField && accountDetails?.level !== "admin"} error="Required" showError={showValidation && !form.buyerName} />
        <CustomInput name="vendorGstIn" label="Vendor GST" value={form.vendorGstIn || ""} onChange={(e: any) => updateForm({ vendorGstIn: e.target.value })} disabled={disabledOtherUserField && accountDetails?.level !== "admin"} />
        <FormControl position="relative" ref={vendorContainerRef} isInvalid={showValidation && !vendorSearch}>
          <FormLabel fontSize="sm" mb={2}>Vendor Code / Name</FormLabel>
          <HStack><Input {...editableInputProps} value={vendorSearch} onChange={(e) => setVendorSearch(e.target.value)} onFocus={() => { if (vendorList.length > 0 && vendorSearch.length >= 2) setShowVendorList(true); }} placeholder="Search..." isRequired={true} disabled={disabledOtherUserField} isInvalid={showValidation && !vendorSearch} />{isVendorLoading && <Spinner size="xs" color="blue.500" />}</HStack>
          {showVendorList && (
            <Portal>
              <Box ref={dropdownRef} position="fixed" top={vendorContainerRef.current?.getBoundingClientRect().bottom} left={vendorContainerRef.current?.getBoundingClientRect().left} width={vendorContainerRef.current?.clientWidth || "300px"} zIndex={1500} bg="white" border="1px solid" borderColor="blue.200" borderRadius="md" boxShadow="2xl" maxH="250px" overflowY="auto">
                <List variant="unstyled">
                  {vendorList.length > 0 ? vendorList.map((v, i) => (
                    <ListItem key={i} px={3} py={3} borderBottom="1px solid" borderColor="gray.50" _hover={{ bg: "blue.50", cursor: "pointer" }} onMouseDown={(e) => { e.preventDefault(); handleSelectVendor(v); }}>
                      <Text fontSize="xs" fontWeight="bold" color="blue.700">{v.vendorCode || "N/A"}</Text>
                      <Text fontSize="2xs" color="gray.600">{v.supplierName || v.label || "N/A"}</Text>
                    </ListItem>
                  )) : <Box px={3} py={3}><Text fontSize="xs" color="gray.500">No vendors found.</Text></Box>}
                </List>
              </Box>
            </Portal>
          )}
        </FormControl>
        <CustomInput name="vendorName" label="Vendor Name" value={form.vendorName || ""} disabled={true} isRequired={true} error="Required" showError={showValidation && !form.vendorName} />
        <CustomInput name="vendorAddress" label="Vendor Address" value={form.vendorAddress || ""} disabled={true} isRequired={true} error="Required" showError={showValidation && !form.vendorAddress} />
        <CustomInput name="vendorPan" label="Vendor PAN" value={form.vendorPan || ""} onChange={(e: any) => updateForm({ vendorPan: e.target.value })} disabled={disabledOtherUserField && accountDetails?.level !== "admin"} />
        <CustomInput name="Invoice_Number" label="Invoice No." value={form.Invoice_Number || ""} onChange={(e: any) => updateForm({ Invoice_Number: e.target.value })} isRequired={true} disabled={disabledOtherUserField && accountDetails?.level !== "admin"} error="Required" showError={showValidation && !form.Invoice_Number} />
        <CustomInput name="Invoice_Date" label="Invoice Date" type="date" value={form.Invoice_Date || ""} onChange={(e: any) => updateForm({ Invoice_Date: e.target.value })} isRequired={true} maxDate={new Date().toISOString().split("T")[0]} disabled={disabledOtherUserField && accountDetails?.level !== "admin"} error="Required" showError={showValidation && !form.Invoice_Date} />
        <CustomInput name="Grand_Total" label="Grand Total" type="number" value={form.Grand_Total || ""} onChange={(e: any) => updateForm({ Grand_Total: e.target.value })} isRequired={true} disabled={disabledOtherUserField && accountDetails?.level !== "admin"} error="Required" showError={showValidation && !form.Grand_Total} />
        <CustomInput
          name="invoiceType"
          label="Invoice Type"
          type="select"
          isBoxSelect
          isRequired={true}
          value={form.invoiceType}
          onChange={(val: any) => updateForm({ invoiceType: val })}
          options={emergingInvoiceTypeOptions}
          disabled={disabledOtherUserField && accountDetails?.level !== "admin"}
          error="Required"
          showError={showValidation && !form.invoiceType}
        />
        <CustomInput name="currency" label="Currency" type="select" isBoxSelect isRequired={true} value={form.currency} onChange={(val: any) => updateForm({ currency: val })} options={addNA(currencyOptions)} disabled={disabledOtherUserField && accountDetails?.level !== "admin"} error="Required" showError={showValidation && !form.currency} />
        <CustomInput name="headerText" label="Header Text" value={form.headerText || ""} onChange={(e: any) => updateForm({ headerText: e.target.value })} isRequired={true} disabled={disabledOtherUserField && accountDetails?.level !== "admin"} error="Required" showError={showValidation && !form.headerText} />
        <CustomInput name="reference1" label="Reference 1" value={form.reference1 || ""} onChange={(e: any) => updateForm({ reference1: e.target.value })} disabled={disabledOtherUserField && accountDetails?.level !== "admin"} />
        <CustomInput name="reference2" label="Reference 2" value={form.reference2 || ""} onChange={(e: any) => updateForm({ reference2: e.target.value })} disabled={disabledOtherUserField && accountDetails?.level !== "admin"} />
        <CustomInput name="reference3" label="Reference 3" value={form.reference3 || ""} onChange={(e: any) => updateForm({ reference3: e.target.value })} disabled={disabledOtherUserField && accountDetails?.level !== "admin"} />
        <CustomInput name="vendorText" label="Vendor Text" value={form.vendorText || ""} onChange={(e: any) => updateForm({ vendorText: e.target.value })} disabled={disabledOtherUserField && accountDetails?.level !== "admin"} />
        {(showValidation && (parseFloat(form.roundOff) < -1 || parseFloat(form.roundOff) > 1)) && (
          <Tooltip label="Round Off must be between -1 and 1" isOpen={true} placement="top" hasArrow colorScheme="red">
            <Box>
              <CustomInput name="roundOff" label="Round Off" value={form.roundOff || "0.00"} disabled={true} error="Round Off must be between -1 and 1" showError={true} />
            </Box>
          </Tooltip>
        )}
      </Grid>

      <Divider mb={4} mt={6} />
      <Box mb={6}>
        <HStack spacing={4} align="center" mb={4}>
          <Text fontSize="sm" fontWeight="bold" color="blue.600" textTransform="uppercase">TDS Details</Text>
          <FormControl display="flex" alignItems="center" width="auto">
            <FormLabel htmlFor="tds-applicable" mb="0" fontSize="xs" fontWeight="bold">TDS Applicable</FormLabel>
            <Switch
              id="tds-applicable"
              size="sm"
              isChecked={form.isTdsApplicable}
              onChange={(e) => updateForm({ isTdsApplicable: e.target.checked })}
              disabled={disabledOtherUserField}
            />
          </FormControl>
        </HStack>

        {form.isTdsApplicable && (
          <Box p={4} borderWidth="1px" borderRadius="md" bg="gray.50">
            <RadioGroup
              value={form.tdsSectionType}
              onChange={(val) => updateForm({ tdsSectionType: val })}
              mb={4}
            >
              <HStack spacing={8}>
                <Radio value="tds" size="sm">Through TDS</Radio>
                <Radio value="gl" size="sm">Through GL Account</Radio>
              </HStack>
            </RadioGroup>

            {form.tdsSectionType === "tds" ? (
              <Grid gridTemplateColumns={"1fr 1fr"} gap={4}>
                <CustomInput
                  name="tdsTaxCode"
                  label="TDS Tax Code"
                  type="select"
                  isBoxSelect
                  options={addNA(tdsTaxCodeOptions)}
                  value={form.tdsTaxCode}
                  onChange={(val: any) => updateForm({ tdsTaxCode: val })}
                  disabled={disabledOtherUserField}
                  isRequired={true}
                  error="Required"
                  showError={showValidation && !form.tdsTaxCode}
                />
                <CustomInput
                  name="tdsBasicAmount"
                  label="TDS Basic Amount"
                  type="number"
                  value={form.tdsBasicAmount || ""}
                  onChange={(e: any) => updateForm({ tdsBasicAmount: e.target.value })}
                  disabled={disabledOtherUserField}
                  isRequired={true}
                  error="Required"
                  showError={showValidation && !form.tdsBasicAmount}
                />
              </Grid>
            ) : (
              <CrmTdsGlSection
                formData={form}
                setFormData={updateForm}
                companyCode={form.companyCode}
                workflowProcess={workflowProcess}
                isDisabled={disabledOtherUserField}
                triggerValidation={triggerValidation}
              />
            )}
          </Box>
        )}
      </Box>

      <Divider mb={4} mt={4} />
      <Box mt={5}>
        <HStack justify="space-between" mb={5}><Text fontSize="lg" fontWeight="semibold" color="blue.700">Line Items</Text><Button size="sm" colorScheme="blue" leftIcon={<AddIcon />} onClick={addLineItem} display={disabledOtherUserField || !["level-1", "level-2", "admin"].includes(accountDetails?.level) ? "none" : undefined}>Add Line Item</Button></HStack>
        {form.lineItems.length > 0 ? (
          <Box borderWidth="1px" borderRadius="md" overflowX="auto">
            <Table variant="simple" size="sm" minW="100%">
              <Thead bg="gray.100" position="sticky" top={0} zIndex={1}>
                <Tr>
                  <Th minW="220px">Profit Center</Th>
                  <Th minW="220px">Cost Center</Th>
                  <Th minW="180px">Business Area</Th>
                  <Th minW="180px">Plant Code</Th>
                  <Th minW="180px">Business Place</Th>
                  <Th minW="180px">HSN Code</Th>
                  <Th minW="220px">Remark</Th>
                  <Th minW="180px">Tax Code</Th>
                  <Th minW="120px">Dr/Cr</Th>
                  <Th minW="300px">Line Narration</Th>
                  <Th minW="220px">GL Account</Th>
                  <Th minW="280px">GL Description</Th>
                  <Th minW="220px">Internal Order</Th>
                  <Th minW="160px">GL Amount</Th>
                  <Th minW="160px">Net Amount</Th>
                  <Th minW="160px">Tax Amount</Th>
                  <Th minW="70px" textAlign="center">Action</Th>
                </Tr>
              </Thead>
              <Tbody>
                {form.lineItems.map((item: LineItem, index: number) => (
                  <Tr key={item.rowId || index} _hover={{ bg: "gray.50" }}>
                    <Td>
                      <Tooltip label="Profit Center is required" isOpen={showValidation && !item.profitCenter} placement="top" hasArrow colorScheme="red">
                        <InputGroup size="sm">
                          <Input
                            {...editableInputProps}
                            value={item.profitCenter || ""}
                            onChange={(e) => updateLineItem(index, { profitCenter: e.target.value })}
                            isInvalid={showValidation && !item.profitCenter}
                            disabled={disabledOtherUserField}
                            style={{ minWidth: "200px" }}
                          />
                          {fetchingRows.has(item.costCenter) && (
                            <InputRightElement>
                              <Spinner size="xs" color="blue.500" />
                            </InputRightElement>
                          )}
                        </InputGroup>
                      </Tooltip>
                    </Td>
                    <Td><Tooltip label="Cost Center is required" isOpen={showValidation && !item.costCenter} placement="top" hasArrow colorScheme="red"><Box><Input {...editableInputProps} value={item.costCenter || ""} onChange={(e) => updateLineItem(index, { costCenter: e.target.value, profitCenter: "" })} isInvalid={showValidation && !item.costCenter} disabled={disabledOtherUserField} style={{ minWidth: "200px" }} /></Box></Tooltip></Td>
                    <Td><Input {...editableInputProps} value={item.businessArea || ""} onChange={(e) => updateLineItem(index, { businessArea: e.target.value })} disabled={disabledOtherUserField} style={{ minWidth: "160px" }} /></Td>
                    <Td><Input {...editableInputProps} value={item.plantCode || ""} onChange={(e) => updateLineItem(index, { plantCode: e.target.value })} disabled={disabledOtherUserField} style={{ minWidth: "160px" }} /></Td>
                    <Td><Input {...editableInputProps} value={item.businessPlace || ""} onChange={(e) => updateLineItem(index, { businessPlace: e.target.value })} disabled={disabledOtherUserField} style={{ minWidth: "160px" }} /></Td>
                    <Td><Input {...editableInputProps} value={item.hsnCode || ""} onChange={(e) => updateLineItem(index, { hsnCode: e.target.value })} disabled={disabledOtherUserField} style={{ minWidth: "160px" }} /></Td>
                    <Td><Input {...editableInputProps} value={item.remark || ""} onChange={(e) => updateLineItem(index, { remark: e.target.value })} disabled={disabledOtherUserField} style={{ minWidth: "220px" }} /></Td>
                    <Td><Input {...editableInputProps} value={item.taxCode || ""} onChange={(e) => updateLineItem(index, { taxCode: e.target.value })} disabled={disabledOtherUserField} style={{ minWidth: "160px" }} /></Td>
                    <Td><CustomInput name={`dc-${index}`} type="select" isBoxSelect value={item.drCrIndicator} onChange={(val: any) => updateLineItem(index, { drCrIndicator: val })} options={[{ label: "Debit", value: "S" }, { label: "Credit", value: "H" }]} disabled={disabledOtherUserField} style={{ minWidth: "120px" }} error="Required" showError={showValidation && !item.drCrIndicator} /></Td>
                    <Td><Tooltip label="Line Narration is required" isOpen={showValidation && !item.lineNarration} placement="top" hasArrow colorScheme="red"><Box><Input {...editableInputProps} value={item.lineNarration || ""} onChange={(e) => updateLineItem(index, { lineNarration: e.target.value })} isInvalid={showValidation && !item.lineNarration} disabled={disabledOtherUserField} style={{ minWidth: "300px" }} /></Box></Tooltip></Td>
                    <Td><Tooltip label="GL Account is required" isOpen={showValidation && !item.glAccount} placement="top" hasArrow colorScheme="red"><Box><Input {...editableInputProps} value={item.glAccount || ""} onChange={(e) => updateLineItem(index, { glAccount: e.target.value })} isInvalid={showValidation && !item.glAccount} disabled={disabledOtherUserField} style={{ minWidth: "200px" }} /></Box></Tooltip></Td>
                    <Td><Input {...editableInputProps} value={item.glDescription || ""} onChange={(e) => updateLineItem(index, { glDescription: e.target.value })} disabled={disabledOtherUserField} style={{ minWidth: "280px" }} /></Td>
                    <Td><Input {...editableInputProps} value={item.internalOrder || ""} onChange={(e) => updateLineItem(index, { internalOrder: e.target.value })} disabled={disabledOtherUserField} style={{ minWidth: "200px" }} /></Td>
                    <Td><Tooltip label="Amount is required" isOpen={showValidation && !item.glAmount} placement="top" hasArrow colorScheme="red"><Box><Input {...editableInputProps} type="number" value={item.glAmount || ""} onChange={(e) => updateLineItem(index, { glAmount: e.target.value })} isInvalid={showValidation && !item.glAmount} disabled={disabledOtherUserField} style={{ minWidth: "160px" }} /></Box></Tooltip></Td>
                    <Td><Input {...editableInputProps} type="number" value={item.netAmount || ""} onChange={(e) => updateLineItem(index, { netAmount: e.target.value })} disabled={disabledOtherUserField} style={{ minWidth: "160px" }} /></Td>
                    <Td><Input {...editableInputProps} type="number" value={item.taxAmount || ""} onChange={(e) => updateLineItem(index, { taxAmount: e.target.value })} disabled={disabledOtherUserField} style={{ minWidth: "160px" }} /></Td>
                    <Td textAlign="center"><IconButton aria-label="Delete" icon={<CloseIcon />} size="sm" colorScheme="red" variant="ghost" onClick={() => removeLineItem(index)} isDisabled={form.lineItems.length === 1 || disabledOtherUserField} /></Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </Box>
        ) : <Text textAlign="center" py={10}>No items</Text>}
      </Box>
    </Box>
  );
}
